import { api } from '@/core/helpers/axiosHelper';

export default {
   async get(company_id?: number, search?: string) {
      return await api
         .get('/team', {
            params: {
               include: 'tenant',
               sort: 'name',
               'filter[tenant.employers.company_id]': company_id,
               'filter[name]': search,
            },
         })
         .then((response) => {
            return response.data;
         });
   },
   async search(tenant_id?: number, search?: string) {
      return await api.get('/team', {
         params: {
            include: 'tenant',
            sort: 'name',
            'filter[tenant_id]': tenant_id,
            'filter[search]': search,
         },
      });
   },
};
